// Claude: split from adminAPI.js — users, upload reports, companies, admin users, KB, feedback 14-04-2026
import { api } from "./config/axiosConfig.js";
import { store } from "../redux/Store.ts";
import { errorResponseHandler, responseHandler } from "../Utils/handler.ts";

export const AdminPlatformAPI = {

  bulkUploadUsers: async (data, params, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: `/auth/bulk-upload-users`,
      method: "POST",
      headers: { Authorization: `Bearer ${token}`, Accept: "form-data" },
      data: data,
      params: params,
    });
    return response.data;
  },

  resetPassword: async (userId, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: `/admin/users/${userId}/change-password`,
      method: "POST",
      headers: { Authorization: `Bearer ${token}`, Accept: "form-data" },
    });
    return response.data;
  },

  // Claude: A1 — upload report list + delete 26-02-2026
  getUploadReports: async (cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: `/auth/upload-reports`,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  deleteUploadReport: async (id, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: `/auth/upload-reports/${id}`,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  // Claude: aggregated companies list from sellers + buyers 01-03-2026
  getCompanies: async () => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: "/admin/companies",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  // Claude: create a new admin user — sends password setup link via email 02-03-2026
  createAdminUser: async (email) => {
    const response = await api.request({
      url: "/auth/signup",
      method: "POST",
      data: { email, role: "Admin" },
    });
    return response.data;
  },

  // Claude: AI Knowledge Base CRUD — Buyer FAQ, Seller FAQ, AI-only entries 13-03-2026
  getKnowledge: async (type) => {
    const { token } = store.getState().user;
    const response = await api.request({
      url: "/ai-knowledge",
      method: "GET",
      params: type ? { type } : {},
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  createKnowledge: async (data) => {
    const { token } = store.getState().user;
    const response = await api.request({
      url: "/ai-knowledge",
      method: "POST",
      data,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  updateKnowledge: async (id, data) => {
    const { token } = store.getState().user;
    const response = await api.request({
      url: `/ai-knowledge/${id}`,
      method: "PATCH",
      data,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  deleteKnowledge: async (id) => {
    const { token } = store.getState().user;
    const response = await api.request({
      url: `/ai-knowledge/${id}`,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  // Claude: sync KB type from local/dev to production MongoDB — full replace 25-03-2026
  syncKnowledgeToProduction: async (mongoUri, type) => {
    const { token } = store.getState().user;
    try {
      const response = await api.request({
        url: "/ai-knowledge/sync-to-production",
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        data: { mongoUri, type },
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  // Claude: admin — list feedback by role 26-03-2026
  getFeedback: async (role) => {
    const { token } = store.getState().user;
    try {
      const response = await api.request({
        url: "/feedback",
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
        params: { role },
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  // Claude: admin — delete feedback (backend enforces 30-day guard) 26-03-2026
  deleteFeedback: async (id) => {
    const { token } = store.getState().user;
    try {
      const response = await api.request({
        url: `/feedback/${id}`,
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

};
